import Vue from 'vue';
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';
import './assets/css/iconfont/iconfont.css';
import './assets/css/common.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/css/all.scss';

import VueRouter from 'vue-router';
import Auth from './services/auth';
import http from './services/http';
import store from './store/store';
import routes from './router';
import App from './App';
import 'babel-polyfill';
import apis from './services/apis';
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
// 全局指令
import './directives/focus.js';
import { Message } from 'element-ui';
Vue.prototype.$message = Message;

Vue.prototype.$commonUrl = global_config.BASE_URL;
Vue.prototype.$commonLoad = global_config.BASE_LOAD;

// 注册全局过滤器
import filter from './filters/index.js'
// import timestamp from '_time-stamp@2.2.0@time-stamp';
for (let i in filter) {
    Vue.filter(i, filter[i]);
}

Vue.prototype.$filter = filter;
Vue.prototype.$http = http;

Vue.prototype.$apis = apis.api;
Vue.prototype.$base = apis.base;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(apis);

//按钮权限(全局)
function hasBtnPermission(id){
    // console.log(id)
    if(store.state.btn.length==0){
        return false
    }else{
        var btn=JSON.stringify(store.state.btn);
        return btn.indexOf(id) > -1;
    }
}
Vue.prototype.hasPerm = hasBtnPermission;
//获取时间戳
function gettime(){
    Date.parse(new Date());
}
//post
var key = '32ADFED602DA49788188858BE1C99068';
function postFn(url, formData, fn) {
    // console.log(url)
    if (localStorage.getItem('userids')) {
        var userId = (localStorage.getItem('userids'))
    // console.log(this.$store.state.routertag)
    } else {
        // console.log(this.$store.state.routertag)
        if (this.$store.state.routertag == 'login' || this.$store.state.routertag == 'index'){
            var userId = '';
        }else{
            this.$router.push({ name: 'login' }); 
            return false
        }
    }
    
    var data = {
        request: {
            head: {
                sign: encodeURIComponent(md5(JSON.stringify(formData) + key)),
                // sign:md5(encodeURIComponent(JSON.stringify(formData)+key)),
                referrerType: '01',
                requestTime: Date.parse(new Date()),
                userId: userId
            },
            body: formData
        }
    }
    data = JSON.stringify(data)
    
    // console.log(data)
    this.$http.post(url, data).then((res) => {
        console.log(url,res)
        var res = res.data.response;
        console.log(res);
        if (res.body.retCode == '0000'||res.body.retCode == '9999' || res.body.retCode == '9000') {
            fn(res)
        } else {
            if (res.body.retCode == '302') {
                // console.log(1)
                Vue.prototype.$message('验签失败，请重新登录');
                
            }
        }
    })
}
Vue.prototype.postFn = postFn;

const router = new VueRouter({
    mode: 'hash',
    base: __dirname,
    routes: routes
});
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
  }

/* router.beforeEach((to, from, next) => {
    // const roles = localStorage.getItem('login');
    // var role=JSON.parse(roles).username;
    // console.log(to)
    //跳转之前判断token是否存在
    // let routeTitle = to.meta.title;
    let routeTitle = 'OA系统后台'
    let routeName = to.name;
    let routePath = to.path;
    window.document.title = routeTitle;
    // console.log(to)
    sessionStorage.setItem('routePath', routeName);
    next()
    // if (!Auth.authenticated()){
    //     router.replace({
    //         name:'login'
    //     });
    //     return false
    // }
    // if (Auth.authenticated() && to.name=='login'){
    //     next('/');
    //     return false
    // }
}); */

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // to 将要访问的路径
    // from 代表从哪个路径跳转而来
    // next 是一个函数，表示放行
    //     next()  放行    next('/login')  强制跳转
  
    if (to.path === '/login') return next()
    // 获取sign
    const signStr = window.sessionStorage.getItem('sign')
    if (!signStr) return next('/login');
    next()
  })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})
export default router;



// WEBPACK FOOTER //
// ./src/main.js